import {Component, computed, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthLayoutComponent} from '../auth-layout/auth-layout';
import {ActionTokenService} from '@/app/features/auth/services/action-token.service';
import {ThemeService} from '@/app/core/services/theme/theme.service';
import { UserStateService } from '@/app/core/states/user_id/user-state.service';
import { ResponseWithCode } from './interface/respose';

@Component({
  selector: 'app-action-token',
  templateUrl: './action-token.html',
  styleUrls: ['./action-token.scss'],
  imports: [AuthLayoutComponent],
})
export class ActionTokenComponent implements OnInit {
  private route = inject(ActivatedRoute);
  protected actionTokenComponent = computed(() => this.themeContent()?.authComponent.actionTokenComponent);
  private router = inject(Router);
  private actionTokenService = inject(ActionTokenService);
  private themeService = inject(ThemeService);
  protected themeContent = this.themeService.themeContent;
  protected userState = inject(UserStateService)

  isProcessing = true;

  ngOnInit(): void {
    this.processToken();
  }

  private processToken(): void {
    // Obtener el token del query param 'key'
    const token = this.route.snapshot.queryParams['key'];

    if (!token) {
      console.error('Token no encontrado en los query parameters');
      this.router.navigate(['/iniciar']);
      return;
    }

    // Hacer la petición al backend para validar el token
    this.validateToken(token);
  }

  private validateToken(token: string): void {
    this.actionTokenService.validateActionToken(token).subscribe({
      next: (response: ResponseWithCode) => {
        console.log("Action token")
        console.log(JSON.stringify(response))
        const code = Number(response.code);

        if (isNaN(code)) {
          console.error('Código inválido del backend:', response.code);
          this.router.navigate(['/message'],
            {
              queryParams:
                { 
                  title: 'Error', 
                  message: 'El código recibido no es válido', 
                  buttonText: 'Regresar al inicio', },
            }); return;
        }

        if (code === 202) {
          this.userState.setToken(response.token);
          this.router.navigate(['/message'], {
            queryParams: {
              title: '¡Correo validado correctamente!',
              message: 'Tu correo electrónico ha sido verificado. Ahora puedes establecer tu contraseña.',
              buttonText: 'Crear contraseña',
              redirectTo: 'new-password',
            },
          })
        }
        else if (code === 200) {
          this.router.navigate(['/new-password'], {
            queryParams: { token: response.token }
          })
        }
        else {
          this.router.navigate(['/message'], {
            queryParams: {
              title: 'Correo validado',
              message: 'Tu correo ha sido validado correctamente',
              buttonText: 'Ir al login',
              redirectTo: 'login'
            },
          });
        }
      },
      error: (error) => {
        this.isProcessing = false;
        this.router.navigate(['/message'], {
          queryParams: {
            title: 'Error',
            message: 'El link ha expirado o no es válido',
            buttonText: 'Regresar al inicio',
          },
        });
      }
    });
  }
}
